import icone from '../assets/icone-suncoast.png';

export function Brand({ className = '' }: { className?: string }) {
  return (
    <span className={`brand ${className}`}>
      <img src={icone} alt="" width={44} height={44} />
      <span className="brand-text">
        <span className="brand-top">Energia Solar</span>
        <span className="brand-bottom">Sun Coast</span>
      </span>
    </span>
  );
}
